import { cn } from '@/lib/utils';

interface ToggleRowProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  highlight?: 'yellow';
}

export function ToggleRow({ label, description, checked, onChange, highlight }: ToggleRowProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between px-4 py-3 min-h-[56px]',
        highlight === 'yellow' && 'border-l-[3px]'
      )}
      style={highlight === 'yellow' ? { borderLeftColor: '#D4A84B' } : undefined}
    >
      <div className="flex-1 mr-4">
        <p className="text-sm font-medium" style={{ color: 'var(--color-text)' }}>
          {label}
        </p>
        {description && (
          <p
            className="text-xs mt-0.5"
            style={{
              color:
                highlight === 'yellow' && checked ? '#D4A84B' : 'var(--color-text-muted)',
            }}
          >
            {description}
          </p>
        )}
      </div>
      <button
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className="relative flex-shrink-0 transition-colors duration-200 cursor-pointer"
        style={{
          width: 44,
          height: 24,
          borderRadius: 12,
          border: 'none',
          background: checked
            ? highlight === 'yellow'
              ? '#D4A84B'
              : 'var(--color-primary)'
            : 'rgba(255,255,255,0.2)',
        }}
      >
        <span
          className="absolute top-[2px] transition-transform duration-200"
          style={{
            width: 20,
            height: 20,
            borderRadius: '50%',
            background: '#fff',
            left: 2,
            transform: checked ? 'translateX(20px)' : 'translateX(0px)',
            display: 'block',
          }}
        />
      </button>
    </div>
  );
}
